import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { RunningExperiments, useExperiments } from 'state/experiments';

interface UseMenuLayoutUpdatesPhaseThreeProps {
  skipLogExposure?: boolean;
}

enum ExperimentVariants {
  TREATMENT = 'treatment',
}

export const useMenuLayoutUpdatesPhaseThree = ({
  skipLogExposure = false,
}: UseMenuLayoutUpdatesPhaseThreeProps = {}): boolean => {
  const experiment = RunningExperiments.MenuLayoutUpdatesPhaseThree;
  const { variant, getVariantValue } = useExperiments();
  const isMobile = useIsMobileBreakpoint();

  if (skipLogExposure) {
    const { value } = getVariantValue(experiment) || {};
    return value === ExperimentVariants.TREATMENT && isMobile;
  }

  return variant(experiment, ExperimentVariants.TREATMENT);
};
